(ns dashboard.components.radiobox
  "Like combobox, but with radio buttons for quick options")

(defn radiobox [{:keys [options disabled value on-set-value on-commit validation-error editable? title]}]
  [:div.field-body
   {:title title}
   [:div.field.has-addons
    [:div.control.is-expanded
     (when editable?
       [:div.is-flex.is-flex-wrap-wrap.is-align-items-center
        (for [option options]
          [:label.radio.ml-0.mr-4
           {:key option}
           [:input.mr-1
            {:type "radio"
             :checked (= value option)
             :disabled disabled
             :on-change (fn [_]
                          (when-not (= value option)
                            (on-set-value option)
                            (when on-commit
                              (on-commit option))))}]
           [:span option]])])
     [:input.input.mt-2
      {:disabled (or (not editable?) disabled)
       :class (when validation-error
                "is-danger")
       :type "text"
       :value value
       :on-change (fn [e]
                    (on-set-value (.. e -target -value)))
       :on-key-down (fn [e]
                      (when (= "Enter" (.-key e))
                        (cond
                          on-commit
                          (on-commit value)

                          on-set-value
                          (on-set-value value))))}]
     (when validation-error
       [:p.help.is-danger validation-error])]]])
